import { Button, Form, Space, message, Checkbox, Alert, Typography } from "antd";
import React, { useState, useEffect } from "react";
import { getVagas } from "../../../../api/vagas";
const { Text } = Typography;

const Vagas = ({ onFinish, onPrevious, loadingComponent }) => {
  const [vagas, setVagas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    listarVagas();
  }, []);

  const listarVagas = async () => {
    setLoading(true);
    try {
      const retorno = await getVagas();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_vagas = [];
        for (let index = 0; index < data?.length; index++) {
          array_vagas.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }
        setVagas(array_vagas);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (values) => {
    onFinish(values);
  };

  return (
    <Form layout="vertical" autoComplete="off" onFinish={onSubmit}>
      {vagas?.length === 0 && (
        <Alert
          message="Atenção"
          description="Não há vagas dinsponíveis no momento, seu currículo será armazenado e será analisado conforme a dispinibilidade de vagas"
          type="info"
          showIcon
        />
      )}

      {vagas?.length > 0 && (
        <Space direction="vertical">
          <Text strong>Se desejar selecione as vagas de interesse abaixo</Text>
          <Form.Item name="vagas" hasFeedback>
            <Checkbox.Group disabled={loading || loadingComponent}>
              <Space direction="vertical">
                {vagas?.map((e) => (
                  <Checkbox key={e?.value} value={e?.value}>
                    {e?.label}
                  </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </Form.Item>
        </Space>
      )}

      <Space>
        <Button size="large" type="primary" loading={loading || loadingComponent} htmlType="submit">
          Finalizar
        </Button>

        <Button size="large" loading={loading || loadingComponent} onClick={onPrevious}>
          Anterior
        </Button>
      </Space>
    </Form>
  );
};

export { Vagas };
